'use client';

import { ComponentProps, PropsWithChildren } from 'react';
// eslint-disable-next-line import/no-self-import
import { SWRConfig } from 'swr';

export const SWRProvider = ({
  children,
  value,
}: PropsWithChildren<ComponentProps<typeof SWRConfig>>) => (
  <SWRConfig
    value={{
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: true,
      ...value,
    }}
  >
    {children}
  </SWRConfig>
);
